export default __webpack_public_path__ + "static/media/1-fairnet-imagemotive-uebersicht.b7b42ac5.jpg";